import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import cx from 'classnames';
import Select from 'react-select/lib/Select';

import OMTextArea from '../OMComponents/OMTextArea/OMTextArea';
import CloudflareCaptcha from '../CloudflareCaptcha/CloudflareCaptcha';
import InputField from '../Company/CompanyContactUs/CompanyField/CompanyField';

import { required, phoneNumber } from '../../helpers/reduxFormValidators';
import { PROFESSIONALS_TYPES, supportEmail } from '../../constants';
import CAPTCHA_ACTIONS from '../../helpers/captchaConstants';

import * as styles from './ProfessionalContactUs.scss';

class ProfessionalContactUs extends Component {
  state = {
    showCaptcha: false
  }

  componentDidMount() {
    if (!this.props.withoutOverflow) {
      document.body.style.overflow = 'hidden';
    }
  }

  componentWillReceiveProps({ formSubmitting, formSubmitted, formError }) {
    if (this.props.formSubmitting && !formSubmitting && formSubmitted) {
      this.props.reset();

      if (!formError) {
        this.props.showMessage({
          message: (
            <div className="successMessage">
              <span>{this.props.translate('companyPage', 'contactsForm', 'submitting_success')}</span>
            </div>
          ),
          messageModalClassName: 'company-message-modal'
        });
        this.props.closeModal();
      }
    }
  }

  componentWillUnmount() {
    document.body.style.overflow = '';
  }

  handleShowCaptcha = () => {
    this.setState({ showCaptcha: true });
  }

  fetchReCaptchaToken = (evt) => {
    this.props.fetchReCaptchaToken(evt);
    return true;
  };

  handleSubmit = (evt) => {
    this.props.handleSubmit(this.props.onSubmit)(evt);
  }

  formatTypeOptions = () => [...Object.values(PROFESSIONALS_TYPES), 'other']
    .map(type => ({
      label: <span>{this.props.translate('professionalsTypes', type)}</span>,
      value: type
    }));

  renderTextArea = ({ input, meta, name, placeholder }) => (
    <OMTextArea
      name={name}
      placeholder={placeholder}
      {...input}
      isInvalid={meta.touched && meta.error && !meta.active}
    />
  );

  renderSelect = ({ input, meta }) => {
    const shouldShowError = (meta.touched && meta.error && !meta.active);
    const options = this.formatTypeOptions();
    return (
      <div className={cx(styles.companyTypeWrap, { 'has-error': shouldShowError })}>
        <Select
          {...input}
          onChange={(option) => input.onChange(option.value)}
          options={options}
          searchable={false}
          clearable={false}
          instanceId="professional"
          rtl={this.props.isRtl}
          placeholder={`${this.props.translate('professionalContactUs', 'companyType')} *`}
          className={cx(styles.numbersSelect,
            { not_valid: shouldShowError })}
        />
      </div>
    );
  };

  render() {
    const translate = this.props.translate('companyPage', 'contactsForm');
    const professionalTranslate = this.props.translate('professionalContactUs');

    return (
      <div className={cx(styles.professionalContactUs, this.props.className)} >
        <div className={styles.textWrapper}>
          <h3>{professionalTranslate('contactUs')}</h3>

          <p className={styles.title}>
            {translate('titleForm')}
          </p>
          <p className={styles.description}>
            {translate('description')}
          </p>
        </div>

        <form onFocus={this.handleShowCaptcha} onSubmit={this.handleSubmit} noValidate="noValidate">
          <div className={styles.horizontalBlock}>
            <Field
              name="name"
              component={InputField}
              type="text"
              placeholder={`${translate('name')} *`}
              validate={[required]}
              translateForError={this.props.translate('errorFieldMessages')}
              isRtl={this.props.isRtl}
            />

            <Field
              name="phone"
              component={InputField}
              type="tel"
              normalize={value => value.replace(/[\D]/g, '')}
              placeholder={`${translate('phone')} *`}
              validate={[required, phoneNumber]}
              translateForError={this.props.translate('errorFieldMessages')}
              isRtl={this.props.isRtl}
            />
          </div>
          <div className={styles.horizontalBlock}>
            <Field
              name="type"
              component={this.renderSelect}
              validate={[required]}
            />

            <Field
              name="city"
              component={InputField}
              type="text"
              placeholder={`${translate('city')} *`}
              validate={[required]}
              translateForError={this.props.translate('errorFieldMessages')}
              isRtl={this.props.isRtl}
            />
          </div>
          <div className={styles.textAreaWrapper}>
            <span className={styles.label}>{translate('message')}</span>
            <Field
              name="message"
              component={this.renderTextArea}
              placeholder={(this.props.isModal || this.props.isMobile) ? `${translate('message')}` : ''}
              translateForError={this.props.translate('errorFieldMessages')}
              isRtl={this.props.isRtl}
            />
          </div>

          {!!this.props.formError && (
            <p className="message" >
              <span>
                {translate('submit_fail_message')} <a href={`mailto:${supportEmail}`}>{supportEmail}</a>
              </span>
            </p>
          )}
          {this.state.showCaptcha && (
            <CloudflareCaptcha
              doReset={this.props.formSubmitted}
              action={CAPTCHA_ACTIONS.CONTACT_US_PROFESSIONAL}
              fetchToken={this.fetchReCaptchaToken}
            />
          )}
            {this.props.formSubmitting ? (
              <button type="button" className="spinner">
                <i className="icon icon-om-spinner om-pulse" />
              </button>
            ) : (
              <input type="submit" value={translate('submit')} />
            )}
        </form>
      </div>
    );
  }
}

ProfessionalContactUs.propTypes = {
  closeModal: PropTypes.func,
  translate: PropTypes.func,
  className: PropTypes.string,
  handleSubmit: PropTypes.func,
  isRtl: PropTypes.bool,
  formSubmitting: PropTypes.bool,
  formSubmitted: PropTypes.bool,
  showMessage: PropTypes.func,
  isMobile: PropTypes.bool,
  formError: PropTypes.object,
  initialValues: PropTypes.object,
  // onSubmit will be triggered by redux form there are no validation errors
  onSubmit: PropTypes.func, // eslint-disable-line react/no-unused-prop-types
  reset: PropTypes.func,
  withoutOverflow: PropTypes.bool,
  isModal: PropTypes.bool,
  fetchReCaptchaToken: PropTypes.func,
  locale: PropTypes.string
};

export default reduxForm({
  form: 'professional-contact-us',
  enableReinitialize: true
})(ProfessionalContactUs);
